<template>
  <!-- don't forget change viewBox and fill params -->
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-rolling">
    <!-- begin -->

    <g :fill="color">
      viewBox%3D'0 0 27 44' path d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E"
    </g>
    <circle cx="50" cy="50" fill="none" :stroke="strokeColor" :stroke-width="strokeWidth" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
      <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform>
    </circle>

    <!-- end -->
  </svg>
</template>

<script>
  export default {
    props: {
      width: { type: String },
      height: { type: String },
      color: { type: String },
      strokeColor: { type: String},
      strokeWidth: { type: Number },
    }
  }
</script>

<style lang="scss">
  .lds-rolling {
    background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/icons/loader.vue